export default __webpack_public_path__ + "static/media/sidebar_staffs_blue.2e82ed46.svg";